import { render } from "./Home.vue?vue&type=template&id=1d6c4060"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=1d6c4060&lang=scss"

import exportComponent from "D:\\DOWNLOAD\\vue\\portfolio_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__